module.exports = __webpack_public_path__ + "img/GTM-integration-vidjet-step1-FR.5cb951d0.png";